import React, { useEffect, useState } from 'react';
import { MultiSelect } from 'primereact/multiselect';
import { Button } from 'primereact/button';
import { useLanguage } from '../../../../contexts/LanguageContext';
import useTrainingPreconditionsData from '../hooks/useTrainingPreconditionsData';

/**
 * Eğitim detayındaki "Ön Koşullar" sekmesi. Bkz. docs/LMS-Egitim-Katalogu-ve-Egitmenler-API 2.md §7.
 *
 * Seçim çoklu (`MultiSelect`); kaydetme her zaman seçili tanım id'lerinin TAMAMINI
 * `LmsTrainingPrecondition/Update` ucuna gönderir (doc §7.5 — gönderilen liste son durumdur).
 */
const PreconditionsTab = ({ trainingId, readOnly = false }) => {
    const { th } = useLanguage();
    const { options, selectedIds, isLoading, hasError, isSaving, savePreconditions } = useTrainingPreconditionsData(trainingId);
    const [localSelection, setLocalSelection] = useState([]);
    const [isDirty, setIsDirty] = useState(false);

    useEffect(() => {
        if (isLoading) return;
        setLocalSelection(selectedIds);
        setIsDirty(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading, trainingId, JSON.stringify(selectedIds)]);

    const handleChange = (e) => {
        setLocalSelection(e.value);
        setIsDirty(true);
    };

    const handleSave = async () => {
        const success = await savePreconditions(localSelection);
        if (success) setIsDirty(false);
    };

    if (hasError) {
        return <div className="text-red-500">{th('trainingCatalog.preconditions.loadError')}</div>;
    }

    return (
        <div>
            <div className="field">
                <label className="block mb-2">{th('trainingCatalog.preconditions.selectLabel')}</label>
                <MultiSelect
                    value={localSelection}
                    options={options}
                    optionLabel="label"
                    optionValue="id"
                    onChange={handleChange}
                    placeholder={th('trainingCatalog.preconditions.selectPlaceholder')}
                    filter
                    display="chip"
                    className="w-full"
                    loading={isLoading}
                    emptyMessage={th('trainingCatalog.preconditions.emptyMessage')}
                />
            </div>

            {!readOnly && (
                <div className="flex justify-content-end mt-3">
                    <Button label={th('common.save')} icon="pi pi-check" onClick={handleSave} loading={isSaving} disabled={!isDirty} />
                </div>
            )}
        </div>
    );
};

export default PreconditionsTab;
